import FacebookGreyIcon from './FacebookGreyIcon';
export default FacebookGreyIcon;
